import { useQuery } from '@tanstack/react-query';

import { callService } from '@api/remote-call';

type Options = {
  type: 'hotel' | 'tour' | 'cruise';
};

export const useGetPopularSearches = ({ type }: Options) => {
  const { data: items } = useQuery({
    queryKey: ['popularSearches', type],
    queryFn: () =>
      callService(
        {
          service: 'SearchesService',
          method: 'searchesGroup',
          version: 'v3',
        },
        { type }
      ),

    enabled: type === 'hotel' || type === 'tour' || type === 'cruise',
    staleTime: 60000,
    cacheTime: 60000,
  });

  return { items };
};
